export const activePage = 0;
export const numberOfItemsPerPage = 50;
export const maxNumberOfItemsPerPage = 100;
export const uploadFileMaxSize = 50 * 1024 * 1024; // byte
export const rowsPerPageOptions = [10, 20, 50, 100];
export const rowsPerPageAgGridOptions = [20, 50, 100];
export const allowedFileFormats =
  '.pdf, vnd.openxmlformats-officedocument.wordprocessingml.document, .png, .jpg, .jpeg, .jfif ,.gif, ' +
  'vnd.openxmlformats-officedocument.spreadsheetml.sheet, vnd.ms-excel, msword, plain, mp4, quicktime, x-ms-wmv, x-msvideo';
export const allowedImageFormats = '.png, .jpg, .jpeg, .jfif';
export const allowedInstructionFormats = '.pdf';
export const allowedFileFormatsText =
  '.pdf, .docx, .png, .jpg, .gif, .xlsx, .csv, .doc, .txt, .mp4, .mov, .wmv, .avi';
export const maxResultPerFilter = ['0', '50', '100', '200'];
export const notAllowedNumberCharacters = ['e', '-', '+'];
export const minPasswordLength = 4;

export const appName = {
  default: 'default',
};
export const locale = {
  default: 'sr',
  sr: 'sr',
  sr_cyr: 'sr_cyr',
};

export const notificationType = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
};

export const localStorageConstants = {
  JWT_TOKEN: 'jwtToken',
  REFRESH_TOKEN: 'refreshToken',
  GOOGLE_2FA_TOKEN: 'google2faToken',
  USER_ROLE_REGEX: 'userRoleRegex',
  TOKEN_EXP_CHECK_INTEVRAL: 'checkTokenExpInterval',
  REFRESH_INTERVAL: 'startRefreshInterval',
  HISTORY_POP_UP: 'historyPopUp',
  LOCALE: 'locale',
  APP_NAME: 'appName',
  APP_VERSION: 'appVersion',
  USERNAME_GENERATOR: 'usernameGen',
  SHOULD_CHANGE_PASSWORD: 'passChange',
  QR_CODE: 'qrCode',
  ALLOWED_ACTIONS: 'allowedActions',
  CODEBOOK_TYPE_ID: 'codebookTypeId',
  PARENT_CODEBOOK_TYPE_NAME: 'parentCodebookTypeName',
  PARENT_CODEBOOK_TYPE_ID: 'parentCodebookTypeId',
  CODEBOOK_TYPE_GROUP_ID: 'codebookTypeGroupId',
};

export const columnTypes = {
  value: 'value',
  action: 'action',
  subobject: 'subobject',
  condition_action: 'condition_action',
  actionWhenKeyIsAction: 'actionWhenKeyIsAction',
  date: 'date',
  boolean: 'boolean',
  enum: 'enum',
  inputField: 'inputField',
  multipleAction: 'multipleAction',
};

export const serverHealthStatus = {
  UP: 'UP',
  DOWN: 'DOWN',
};

export const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const filterTypesAgGrid = {
  NUMBER: 'number',
  DATE: 'date',
  SET: 'set',
  BOOLEAN: 'boolean',
  TEXT: 'text',
};

export const fieldTypesAgGrid = {
  DATE: 'date',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  ACTION: 'action',
};

export const fieldTypes = {
  LABEL: 'label',
  STRING: 'string',
  MAX_LENGTH: 'maxLength',
  WIDTH: 'width',
  NUMBER: 'number',
  ACTION: 'action',
  ORDER_NUM: 'orderNum',
};

export const codeTypes = {
  NUMBER: 'NUMBER',
  CHARACTER: 'CHARACTER',
  CHARACTER_NUMBER: 'CHARACTER_NUMBER',
};

export const formFieldTypes = {
  TEXT: 'text',
  STRING: 'STRING',
  LONG_STRING: 'LONG_STRING',
  AUTOCOMPLETE: 'autocomplete',
  COMBO_BOX: 'COMBO_BOX',
  DATE: 'date',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
};

export const AppButtonIcon = {
  CREATE: 'fas fa-plus',
  UPDATE: 'fas fa-edit',
  DELETE: 'fas fa-trash-alt',
  PREVIEW: 'fas fa-magnifying-glass',
  REMOVE: 'fas fa-minus',
};

export const maxLongStringLength = 1000;
export const maxShortStringLength = 80;

export const timeFormat = '00:00:00';
